import { Button, Flex, Heading, useBoolean } from '@chakra-ui/react'
import type { InsuranceParamsPagedQuery } from 'BrokerTsLib/src/dtos'
import { Product } from 'BrokerTsLib/src/enums'
import { createContext, useEffect, useState } from 'react'

import { useApp } from '@/hooks/useApp'

import type { IPaginationContext } from 'BrokerTsLib/src/interfaces/Pagination/Pagination'
import { Container } from '../../components/Container'
import { Section } from '../../components/Section'
import { ConceptsList } from '../../containers/concepts'
import { PageContent } from '../../containers/PageContent'
import { PageToolbar } from '../../containers/PageToolbar'
import { ConceptsPropertySearch } from '../../containers/search/chaloupka/ConceptsPropertySearch'
import { SearchButton } from '../../containers/search/SearchButton'
import { useGetAll } from '../../hooks/useInsuranceParams'
import { Select } from '../../icons'

export const conceptsPropertyContext = createContext<IPaginationContext<InsuranceParamsPagedQuery>>({} as IPaginationContext<InsuranceParamsPagedQuery>)

export const ConceptsPropertyPage = () => {
  const { setProduct } = useApp()

  const [isOpen, setOpen] = useBoolean(false)
  const [allowSelect, setAllowSelect] = useBoolean(false)

  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [deletedCounter, setDeletedCounter] = useState(0)
  const [filter, setFilter] = useState<InsuranceParamsPagedQuery>({
    listType: 1,
    pageIndex: 1,
  })

  const { data, mutateAsync: getAllAsync, isLoading: isLoading } = useGetAll()
  const items = data?.data

  const reloadData = () => setDeletedCounter(deletedCounter + 1)

  useEffect(() => {
    setFilter({ ...filter, pageSize: pageSize, pageIndex: currentPage })
  }, [pageSize, currentPage])

  useEffect(() => {
    if (filter.pageSize) // nechci spoustet nacitani na pageload 2x
      getAllAsync(filter)
  }, [filter, deletedCounter])

  // Resetovat product na PropertyInsurance
  useEffect(() => {
    setProduct(Product.PropertyInsurance)
  }, [])

  return (
    <Section>
      <Container>
        <PageContent>
          <conceptsPropertyContext.Provider value={
            {
              loading: isLoading,
              totalCount: items?.totalCount ?? 0,
              currentPage: currentPage,
              pageSize: pageSize,
              filter: filter,
              setCurrentPage: setCurrentPage,
              setPageSize: setPageSize,
              updateFilter: f => setFilter(f),
              reload: reloadData
            }
          }>
            <PageToolbar
              leftElements={
                <Flex sx={{ gap: 4, alignItems: 'center' }}>
                  <Heading as="h1">Rozpracované nabídky</Heading>
                </Flex>
              }
              rightElements={
                <Flex sx={{ gap: 4 }}>
                  <Button variant="ghost" onClick={setAllowSelect.toggle}>
                    <Select color="secondary.500" />
                    {allowSelect ? 'Zrušit smazání' : 'Vybrat ke smazání'}
                  </Button>
                  <SearchButton isOpen={isOpen} setOpen={setOpen} />
                </Flex>
              }
            />

            {isOpen && <ConceptsPropertySearch />}

            <ConceptsList concepts={items?.items ?? []} withPaginator allowSelect={allowSelect} />
          </conceptsPropertyContext.Provider>
        </PageContent>
      </Container>
    </Section>
  )
}
